function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocFbW = function SvgSocFbW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 12.3 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.7 13H8.1v13H2.6V13H0V8.3h2.6V5.5c0-2.1 1-5.5 5.5-5.5H12v4.4H9.1c-.5 0-1 .3-1 1.3v2.6h4.2Z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgSocFbW;